import request from './request'

export function listSalesPlan(data) {
  return request.post('/sales/sales-plans/list', data)
}
export function getSalesPlan(id) {
  return request.get('/sales/sales-plans/' + id)
}
export function saveSalesPlan(data) {
  return request.post('/sales/sales-plans', data)
}
export function updateSalesPlan(data) {
  return request.post('/sales/sales-plans/update', data)
}
export function deleteSalesPlan(ids) {
  return request.post('/sales/sales-plans/delete', ids)
}
export function confirmSalesPlan(salesPlanId) {
  return request.post('/sales/sales-plans/confirm', { salesPlanId })
}
export function unconfirmSalesPlan(salesPlanId) {
  return request.post('/sales/sales-plans/unconfirm', { salesPlanId })
}
export function generateMasterOrderFromPlan(data) {
  return request.post('/sales/sales-plans/generate-master-order', data)
}
